// src/components/Layout.js

import React from "react";
import Header from "./header"; // Fixed casing for 'header.js'
import Footer from "./footer"; // Fixed casing for 'footer.js'

function Layout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default Layout;